import { render, staticRenderFns } from "./gsCyIndex.vue?vue&type=template&id=3f754934&scoped=true&"
import script from "./gsCyIndex.vue?vue&type=script&lang=js&"
export * from "./gsCyIndex.vue?vue&type=script&lang=js&"
import style0 from "./gsCyIndex.vue?vue&type=style&index=0&id=3f754934&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f754934",
  null
  
)

export default component.exports